import React, { Component } from 'react'
import '../styles/GlobalStyle.css'
import { db, firebase } from '../firebase/Firebase'
import { flattenDoc, linkAfterLogin } from '../Util'
import ColType from '../Types'
import { message, Form, Input, Button, Icon } from 'antd'
import CustomFooter from './CustomFooter'
const FormItem = Form.Item

const errorMessage = (description) => {
    message.error(description)
}

class DemoSignIn extends Component {
    state = {
        cleverCode: '',
        cleverScope: null,
        cleverState: null,
        userRole: '',
        signingIn: false,
        cleverCodeError: false,
        userNotFoundError: false,
        userArchivedError: false,
    }

    componentDidMount() {
        if (!this.props.role) {
            document.title = "Sign in - Dot It"
        }
    }

    componentWillUnmount() {

    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            message.destroy()
            if (!err) {
                this.setState({
                    signingIn: true,
                }, () => {
                    firebase.auth().signInWithEmailAndPassword(values.organization + '@dotit.app', values.password)
                        .then(() => {
                            if (this.props.role) {
                                this.demoSignIn(this.props.role);
                            } else {
                                this.demoSignIn('admin');
                            }
                        })
                        .catch((error) => {
                            var errorCode = error.code
                            var errorMessageString = error.message
                            if (errorMessageString === 'There ' +
                                'is no user record corresponding to this identifier. ' +
                                'The user may have been deleted.') {
                                errorMessageString = 'This account does not exist.'
                            }
                            else if (errorMessageString === 'The password is invalid ' +
                                'or the user does not have a password.') {
                                errorMessageString = 'Organization or password is incorrect.'
                            } else {
                                errorMessageString = 'Organization or password is incorrect.'
                            }
                            errorMessage(errorMessageString)
                            this.setState({
                                signingIn: false,
                            })
                        })
                })
            }
        })
    }

    demoSignIn = async (role) => {
        if (!(role === 'admin' || role === 'coach' || role === 'teacher' || role === 'student')) {
            return
        }

        this.setState({
            signingIn: true,
        })

        firebase.auth().currentUser.getIdToken(true).then((idToken) => {
            let headers = new Headers()
            headers.append('Authorization', 'Bearer ' + idToken)
            headers.append('Content-Type', 'application/json')

            fetch("https://us-central1-education-9d7f3.cloudfunctions.net/app/dotit/clever-create-token-from-id", {
                method: "POST",
                body: JSON.stringify({
                    demoRole: role,
                }),
                mode: 'cors',
                headers: headers,
            })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error('Response status: ' + res.status)
                    }
                    return res.json()
                })
                .then(data => {
                    firebase.auth().signInWithCustomToken(data.token)
                        .then((userObj) => {
                            const user = userObj.user
                            db.collection(ColType.users)
                                .doc(user.uid)
                                .get()
                                .then((doc) => {
                                    var userInfo = flattenDoc(doc)
                                    if (userInfo.accessLevel === 'superAdmin') {
                                        window.location.href = '/super-admin/add-initial-admin'
                                        return
                                    }
                                    else {
                                        db.collection(userInfo.accessLevel)
                                            .doc(userInfo.refId)
                                            .get()
                                            .then((doc) => {
                                                var userJobInfo = flattenDoc(doc)
                                                if (userInfo.accessLevel === "teachers" && this.state.cleverState) {
                                                    window.location.href = this.state.cleverState
                                                } else {
                                                    linkAfterLogin(userInfo, userJobInfo)
                                                }
                                            })
                                    }
                                }).catch((error) => {
                                    console.log('get user info error', error)
                                    this.setState({
                                        signingIn: false,
                                    })
                                })
                        })
                        .catch((error) => {
                            console.log('student sign in error', error)
                            this.setState({
                                signingIn: false,
                            })
                        })
                })
                .catch(error => {
                    console.log('error', error)
                    this.setState({
                        signingIn: false,
                    })
                })
        }).catch((error) => {
            console.log('error', error)
            this.setState({
                signingIn: false,
            })
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const formItemLayout = {
            labelCol: {
                xs: { span: 25 },
                sm: { span: 0 },
            },
            wrapperCol: {
                xs: { span: 25 },
                sm: { span: 24 },
            },
        }

        return (
            <div className={!this.props.role ? "pt-4 pb-70 relative" : ''} style={{ minHeight: '100%' }}>


                <div className='relative'>
                    {!this.props.role ?
                        <div className="text-center mb-3">
                            <div className="text-center mb-4 mt-2">
                                <img src='/dotit-logo-color-new.png' alt='logo' height='70' />
                            </div>
                        </div>
                        : ''}

                    <div className={!this.props.role ?
                        "p-4 w-500 m-lr-auto br-20 ant-shadow background-fff"
                        : ''}>
                        {!this.props.role ?
                            <div>
                                <div className="block w-100 m-lr-auto mb-1 text-center">
                                    <img src="/dot-it-sign-in.png" alt="sign-in" height="150" />
                                </div>
                                <div className="mb-3 text-center pt-3 font-30 font-bold">Sign in to Dot It</div>
                            </div> : ''}
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <FormItem {...formItemLayout} label="Organization">
                                {getFieldDecorator('organization', {
                                    rules: [{ required: true, message: 'Please input your organization.' }],
                                })(
                                    <Input
                                        size={"large"}
                                        placeholder="Organization..." />
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="Password">
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: 'Please input a password.' }],
                                })(
                                    <Input
                                        size={"large"}
                                        type="password"
                                        placeholder="Password..." />
                                )}
                            </FormItem>
                            <FormItem className="mb-0">
                                <Button
                                    disabled={this.state.signingIn}
                                    size={"large"}
                                    type="primary"
                                    htmlType="submit"
                                    className="full-width-btn mt-05">
                                    {!this.state.signingIn ?
                                        <span className="font-bold">Sign in</span> :
                                        <span className="font-bold">
                                            <Icon type="loading" className="mr-8" />Signing in...</span>
                                    }
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                    {!this.props.role ?
                        <CustomFooter
                            theme='dark'
                        />
                        : ''}
                </div>
            </div>

        )
    }
}

export default Form.create()(DemoSignIn)